<template>
 <sdPageHeader title="Duurzaamheidsadvies aanvragen"></sdPageHeader>
 <Main>
  <a-row :gutter="25">
   <a-col :span="24">
    <WizardBlock>
     <a-row>
      <a-col :span="24">
       <WizardWrapper>
        <Steps
         :current="current"
         :isFinished="isFinished"
         :status="status"
         :steps="steps"
         size="small"
         @onDone="done"
         @onPrev="prev"
        >
         <template #address>
          <sdCards title="Adres selecteren">
           <a-row justify="center">
            <a-col :sm="24" :xs="24">
             <div class="create-account-form">
              <a-form
               :model="addressForm"
               :rules="addressFormRules"
               layout="vertical"
               name="account"
               @finish="globalSearch"
              >
               <a-row :gutter="30">
                <a-col :sm="10" :xs="24">
                 <a-form-item label="Postcode" name="postalCode">
                  <a-input v-model:value="addressForm.postalCode" placeholder=""/>
                 </a-form-item>
                </a-col>
                <a-col :sm="4" :xs="24">
                 <a-form-item label="Huisnummer" name="houseNumber">
                  <a-input v-model:value="addressForm.houseNumber"
                           onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
                           onpaste="let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}"
                           placeholder="" type="number"/>
                 </a-form-item>
                </a-col>
                <a-col :sm="4" :xs="24">
                 <a-form-item v-if="houseNumberAdditionsOptions.length > 0" label="Toevoeging"
                              name="houseNumberAddition"
                 >
                  <a-select v-model:value="addressForm.houseNumberAddition" :allowClear="true"
                            class="sDash_fullwidth-select"
                            size="large">
                   <a-select-option v-for="(item,index) in houseNumberAdditionsOptions"
                                    :key="index"
                                    :value="item.value">
                    {{ item.key }}
                   </a-select-option>
                  </a-select>
                 </a-form-item>
                </a-col>
                <a-col :sm="6" :xs="24">
                 <a-form-item label="&nbsp;">
                  <a-button :disabled="disabledGlobalSearchButton||globalSearchLoading||loadingHouseNumberAdditions"
                            :loading="globalSearchLoading||loadingHouseNumberAdditions" class="btn-signin w-100"
                            html-type="submit"
                            size="large"
                            type="primary">
                   Zoeken
                  </a-button>
                 </a-form-item>
                </a-col>
               </a-row>
              </a-form>
             </div>
            </a-col>
           </a-row>
          </sdCards>
          <a-row v-if="globalSearchData && globalSearchData.address" :gutter="30">
           <a-col :md="14">
            <sdCards title="Klant selecteren">
             <a-row style="padding: 0 !important;">
              <a-col :xs="24" class="mb-10">
               <a-col class="about-connection-wrapper">
                <sdHeading as="h6" class="mb-5" style="font-size:14px">Nieuwe klanten</sdHeading>
                <a-row :gutter="20"
                       style="padding: 10px !important;border: 1px solid rgba(34,41,47,.125);border-radius:5px;">
                 <a-col :xl="16" :xs="24"
                        class="p-2 mb-2" style="vertical-align: middle;display: table-cell;align-self: center">
                  {{ globalSearchData.address.street }}
                  {{
                   globalSearchData.address.houseNumber
                  }} {{
                   globalSearchData.address.houseNumberAddition ? globalSearchData.address.houseNumberAddition : ''
                  }}<br/>
                  {{ globalSearchData.address.postalCode }} {{ globalSearchData.address.city }} <br/>Nederland
                 </a-col>
                 <a-col :xl="8" :xs="24" justify="end"
                        style="vertical-align: middle;align-self: center;text-align: end">
                  <a-button :disabled="loadingPreFillRelationOnOrder"
                            :loading="loadingPreFillRelationOnOrder"
                            class="mr-2 mb-2 mt-2 w-100"
                            size="large"
                            type="primary-outlined"
                            @click.prevent="handleSelectAddress(globalSearchData.address,'CONSUMER')">
                   Doorgaan als particulier
                  </a-button>
                  <a-button :disabled="loadingPreFillRelationOnOrder"
                            :loading="loadingPreFillRelationOnOrder"
                            class="mb-2 mt-2 w-100"
                            size="large"
                            type="primary-outlined"
                            @click.prevent="handleSelectAddress(globalSearchData.address,'BUSINESS')">
                   Doorgaan als zakelijk
                  </a-button>
                 </a-col>
                </a-row>
               </a-col>
              </a-col>
             </a-row>
             <a-row v-if="globalSearchData.relations.length > 0" justify="center">
              <a-col :sm="24" :xs="24" class="mb-10">
               <a-col class="about-connection-wrapper">
                <sdHeading as="h6" class="mb-5" style="font-size:14px">Bestaande klanten</sdHeading>
                <a-row v-for="relation in globalSearchData.relations" :key="relation.id" :gutter="20"
                       style="padding: 10px !important;border: 1px solid rgba(34,41,47,.125);border-radius:5px;margin-bottom: 8px !important;">
                 <a-col :xl="18" :xs="24" style="vertical-align: middle;display: table-cell;align-self: center;">
                                    <span><strong>{{ relation.fullName }}</strong>
                                      <span class="status-badge ml-2">{{
                                        relation.type && relation.type === 'BUSINESS' ? 'Zakelijk' : 'Particulier'
                                       }}</span>
                                    </span><br/>
                  <span>{{ relation.street }} {{
                    relation.houseNumber
                   }} {{
                    relation.houseNumberAddition ? relation.houseNumberAddition : ''
                   }}<br/> {{ relation.postalCode }} {{ relation.city }}<br/> Nederland</span><br/>
                 </a-col>
                 <a-col :xl="6" :xs="24"
                        style="vertical-align: middle;display: flex;align-self: center;justify-content: end;">
                  <a-button :disabled="loadingPreFillRelationOnOrder"
                            :loading="loadingPreFillRelationOnOrder"
                            class="mr-2 mb-2 mt-2 w-100"
                            size="large"
                            type="primary-outlined"
                            @click.prevent="handleSelectAddress(relation,relation.type)"> Selecteren
                  </a-button>
                 </a-col>
                </a-row>
               </a-col>
              </a-col>
             </a-row>
             <a-row v-if="globalSearchData.coc.length > 0" justify="center">
              <a-col :sm="24" :xs="24" class="mb-2">
               <sdHeading as="h6" class="mb-5" style="font-size:14px">Gevonden in<img
                :src="require(`@/static/img/kvk.svg`)"
                alt="" class="ml-5"/></sdHeading>
               <a-row v-for="coc in globalSearchData.coc" :key="coc.companyCocNumber" :gutter="30"
                      style="padding: 10px !important;border: 1px solid rgba(34,41,47,.125);border-radius:5px;margin-bottom: 8px !important;">
                <a-col :xl="14" :xs="24"
                       class="p-2" style="vertical-align: middle;display: table-cell;align-self: center">
                                  <span><strong>{{ coc.companyName }} - {{
                                    coc.companyCocNumber
                                   }}</strong></span><br/>
                 <span>{{ coc.street }} {{
                   coc.houseNumber
                  }} {{
                   coc.houseNumberAddition ? coc.houseNumberAddition : ''
                  }}<br/> {{ coc.postalCode }} {{ coc.city }}<br/>Nederland</span>
                </a-col>
                <a-col :xl="10" :xs="24" justify="end"
                       style="vertical-align: middle;align-self: center;text-align: end">
                 <a-button :disabled="loadingPreFillRelationOnOrder"
                           :loading="loadingPreFillRelationOnOrder"
                           class="mr-2 mb-2 mt-2 w-100"
                           size="large"
                           type="primary-outlined"
                           @click.prevent="handleSelectAddress(coc,'BUSINESS')"> Doorgaan als zakelijk
                 </a-button>
                </a-col>
               </a-row>
              </a-col>
             </a-row>
            </sdCards>
           </a-col>
           <a-col :md="10">
            <sdCards style="text-align: center" title="Locatie">
             <img :src="globalSearchData.streetViewImageFileURL" style="width: 100%;height: auto;border-radius:5px">
            </sdCards>
           </a-col>
          </a-row>
          <ActionWrapper>
           <div class="step-action-wrap">
            <div class="step-action-inner">
             <a-row>
              <a-col :xs="24">
               <div class="steps-action">
                <router-link to="/order/flow">
                 <sdButton class="btn-prev" to="" type="primary">
                  <sdFeatherIcons size="16" type="arrow-left"/>
                  <span>Vorige</span>
                 </sdButton>
                </router-link>
               </div>
              </a-col>
             </a-row>
            </div>
           </div>
          </ActionWrapper>
         </template>

         <template #relation>
          <a-form ref="relationForm" :model="order" layout="vertical">
            <Relation
             :key="relKey"
             ref="relationComponentRef"
             :disable-is-business="true"
             :is-order-create="true"
             :maxAge="80"
             :minAge="18"
             :relation="order.relation"
             :show-card-save-button="false"
             :show-footer="false"
             :show-global-save-button="true"
             :showHeader="false"
             type="ADD"
             @submit-external="handleRelationOnOrder($event)"
            ></Relation>
          </a-form>

          <a-row v-if="order.flowQuestions && order.flowQuestions.length > 0" :gutter="25">
            <a-col :xs="24">
              <sdCards title="Product vragen">
                <a-form ref="flowQuestionsForm" :model="{flowQuestions:order.flowQuestions}"
                        layout="vertical">
                  <a-row :gutter="25">
                    <a-col v-for="(item,index) in order.flowQuestions" :key="index" :md="12" :xs="24">
                      <FlowQuestionFormItem :index="index" :item="item"/>
                    </a-col>
                  </a-row>
                </a-form>
              </sdCards>
            </a-col>
          </a-row>

          <ActionWrapper>
           <div class="step-action-wrap">
            <div class="step-action-inner">
             <a-row>
              <a-col :xs="24">
               <div class="steps-action">
                <sdButton class="btn-prev" type="primary" @click="() => prev()">
                 <sdFeatherIcons size="16" type="arrow-left"/>
                 <span>Vorige</span>
                </sdButton>
                <sdButton
                 :disabled="loadingCreateOrder"
                 :loading="loadingCreateOrder"
                 class="btn-next"
                 type="primary"
                 @click.prevent="handleRelationSubmitAndCreateOrder()"
                >
                 <span>Aanvragen</span>
                 <sdFeatherIcons size="16" type="check"/>
                </sdButton>
               </div>
              </a-col>
             </a-row>
            </div>
           </div>
          </ActionWrapper>
         </template>
        </Steps>
       </WizardWrapper>
      </a-col>
     </a-row>
    </WizardBlock>
   </a-col>
  </a-row>
 </Main>
</template>

<script>
import {CardWrapper, WizardBlock, WizardWrapper,} from './Style';
import {BasicFormWrapper, Main} from '../styled';
import Steps from "./component/steps";
import {useStore} from "vuex";
import {computed, onMounted, reactive, ref} from "vue";
import Relation from "../../components/relation/Relation";
import FlowQuestionFormItem from "@/components/flowQuestion/FlowQuestionFormItem";
import {ActionWrapper} from "@/components/steps/style";
import {postalCodeValidator, integerValidator} from "@/utility/validators";

import {notification} from "ant-design-vue";
import {useRoute, useRouter} from "vue-router";

const OrderSustainabilityConsultation = {
 name: 'OrderSustainabilityConsultation',
 components: {
  CardWrapper,
  WizardBlock,
  Main,
  Steps,
  WizardWrapper,
  BasicFormWrapper,
  Relation,
  ActionWrapper,
  FlowQuestionFormItem,
 },
 data() {
  return {
   customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
   debounce: null,
   selectedAddress: {
    postalCode: '',
    houseNumber: '',
   },
  };
 },
 watch: {
  addressForm: {
   handler(value) {
    if ((value.postalCode && value.houseNumber) && (this.selectedAddress.postalCode !== value.postalCode || this.selectedAddress.houseNumber !== value.houseNumber)) {
     this.selectedAddress.postalCode = value.postalCode;
     this.selectedAddress.houseNumber = value.houseNumber;
     clearTimeout(this.debounce)
     this.debounce = setTimeout(() => {
      this.$store.dispatch("houseNumberAdditions", {
       postalCode: this.addressForm.postalCode,
       houseNumber: this.addressForm.houseNumber,
       country: this.addressForm.country,
       type: 'SHOP',
      });
     }, 600)
    }
   },
   deep: true,
  }
 },
 setup() {
  const {state, dispatch} = useStore();
  const router = useRouter()
  const {params} = useRoute();
  const status = ref("process");
  const isFinished = ref(false);
  const current = ref(0);

  const addNotificationError = (err) => {
   notification.error({
    message: err,
   });
  };

  const relationComponentRef = ref();
  const relationForm = ref();
  const flowQuestionsForm = ref();
  const houseNumberAdditionsOptions = computed(() => state.globalSearch.houseNumberAdditions);
  const globalSearchData = computed(() => state.globalSearch.data);
  const globalSearchLoading = computed(() => state.globalSearch.loadingSearch);
  const disabledGlobalSearchButton = computed(() => state.globalSearch.disabledGlobalSearchButton);
  const order = reactive(computed(() => state.sustainabilityConsultation.order));
  const loadingCreateOrder = computed(() => state.sustainabilityConsultation.loadingCreateOrder);
  const loadingPreFillRelationOnOrder = computed(() => state.sustainabilityConsultation.loadingPreFillRelationOnOrder);
  const loadingHouseNumberAdditions = computed(() => state.globalSearch.loadingHouseNumberAdditions);
  let relKey = ref(0);

  const next = () => {
   status.value = "process";
   current.value = current.value + 1;
  };

  const prev = () => {
   status.value = "process";
   current.value = current.value - 1;
  };

  const done = () => {
   const confirm = window.confirm("Are sure to submit order?");
   if (confirm) {
    status.value = "finish";
    isFinished.value = true;
    current.value = 0;
   }
  };

  const addressForm = reactive({
   postalCode: '',
   houseNumber: '',
   houseNumberAddition: '',
   country: 'NL'
  });

  const addressFormRules = {
   postalCode: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
    {
     validator: postalCodeValidator,
    },
   ],
   houseNumber: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
    {
     validator: integerValidator,
    },
   ],
   houseNumberAddition: [
    {
     required: true,
     message: 'Dit veld is verplicht',
    },
   ],
  };

  const handleSelectAddress = (data, type) => {
   if (type) {
    // Handle relation selection with type
    const relationData = {
     ...data,
     type: type
    };
    dispatch('preFillRelationOnSustainabilityConsultationOrder', {
     value: relationData,
     stepRoute: next
    });
   } else {
    // Handle simple address selection
    addressForm.postalCode = data.postalCode;
    addressForm.houseNumber = data.houseNumber;
    addressForm.houseNumberAddition = data.houseNumberAddition;
    addressForm.country = data.country;

    dispatch('preFillRelationOnSustainabilityConsultationOrder', {
     value: data,
     stepRoute: next
    });
   }
  };

  const globalSearch = () => {
   dispatch('globalSearch', {
    postalCode: addressForm.postalCode,
    houseNumber: addressForm.houseNumber,
    country: addressForm.country,
    type: 'SHOP',
   });
  };

  const handleRelationOnOrder = (data) => {
   relKey.value++;
   dispatch('addRelationToSustainabilityConsultationOrder', {
    value: data,
    stepRoute: handleCreateOrder
   });
  };

  const handleRelationSubmitAndCreateOrder = () => {
   // First validate and submit the relation data, then create the order
   relationComponentRef.value.submitExternal();
  };

  const orderCreateSuccessRoute = () => {
   router.push('/order');
  };

  const handleCreateOrder = () => {
   const orderValidators = [];

   // Validate relation form if it exists
   if (relationForm.value) {
     orderValidators.push(relationForm.value.validate());
   }

   // Validate flow questions form if it exists
   if (flowQuestionsForm.value) {
     orderValidators.push(flowQuestionsForm.value.validate());
   }

   Promise.all(orderValidators).then(() => {
    const orderData = JSON.parse(JSON.stringify(order.value));
    // Ensure productID is set from URL parameters
    orderData.productID = params.productID;
    dispatch('createSustainabilityConsultationOrder', {
     successRoute: orderCreateSuccessRoute,
     orderData
    })
   })
    .catch(() => {
     addNotificationError('Vul alle benodigde informatie in.');
    });
  };

  onMounted(async () => {
   console.log('OrderSustainabilityConsultation onMounted - productID:', params.productID);
   await dispatch('resetSustainabilityConsultationOrder');
   console.log('About to fetch flow questions...');
   await dispatch('fetchSustainabilityConsultationFlowQuestions', {productID: params.productID});
   console.log('Flow questions fetch completed');
  });

  return {
   steps: [
    {
     title: "Adres",
     content: "address",
    },
    {
     title: "Klantgegevens",
     content: "relation",
    },
   ],
   addressForm,
   houseNumberAdditionsOptions,
   addressFormRules,
   globalSearchData,
   order,
   globalSearchLoading,
   disabledGlobalSearchButton,
   relationComponentRef,
   relationForm,
   flowQuestionsForm,
   handleSelectAddress,
   globalSearch,
   done,
   prev,
   next,
   handleRelationOnOrder,
   handleRelationSubmitAndCreateOrder,
   handleCreateOrder,
   isFinished,
   current,
   status,
   loadingPreFillRelationOnOrder,
   loadingCreateOrder,
   loadingHouseNumberAdditions,
   relKey,
  };
 },
};

export default OrderSustainabilityConsultation;
</script>

<style>
.steps-content {
 display: block !important;
}

.status-badge {
 font-size: 12px;
 padding: 0 12.41px;
 line-height: 1.9;
 font-weight: 500;
 border-radius: 12px;
 text-transform: capitalize;
 display: inline-block !important;
 background-color: #519c79;
 color: #ffffff;
}

.ant-collapse-item {
 margin-bottom: 15px !important;;
}

.ant-collapse .collapse-title {
 width: 100% !important;
 display: flex !important;
 align-items: baseline !important;
}
</style>
